import {getUserData} from '@common'
import {APIMethod, UserRole} from '@enums'
import {getUserSelectionAtom} from '@state'

import {fetchData} from 'api/api'
import {getDefaultStore} from 'jotai'

import {UserRequest, UserResponse} from './types'

/**
 * @returns All Users
 */
export const getUsers = async (): Promise<UserResponse[]> => {
  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser.id]

  switch (currentUser.role) {
    case UserRole.SUPER_ADMIN:
      return fetchData<undefined, UserResponse[]>({
        method: APIMethod.GET,
        url: 'user/all',
      })
    case UserRole.PARENT_ADMINISTRATOR:
      return fetchData<undefined, UserResponse[]>({
        method: APIMethod.GET,
        url: `user/parent-company/${userSelection?.parentCompanyId || ''}/users`,
      })
    default:
      return fetchData<undefined, UserResponse[]>({
        method: APIMethod.GET,
        url: `user/company/${userSelection?.companyId || ''}`,
      })
  }
}

/**
 * @param id Company ID
 * @returns All Users with a specific Company ID
 */
export const getUsersByCompany = async (id: string): Promise<UserResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `user/company/${id}`,
  })
}

/**
 * @param id User ID
 * @returns A single User with a specific ID
 */
export const getUserById = async (id: string): Promise<UserResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `user/${id}`,
  })
}

/**
 * Updates an existing User
 * @param id User ID
 * @param body User payload data
 * @returns Updated User data
 */
export const updateUser = async (id: string, body: UserRequest): Promise<UserResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `user/${id}`,
    body,
  })
}

/**
 * Creates a new User
 * @param body User payload data
 * @returns New User data
 */
export const createUser = async (body: UserRequest): Promise<UserResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: `user`,
    body,
  })
}
